import type { ReactNode } from 'react'
import { useTheme } from '../../hooks/useTheme'

interface DashedPlaceholderProps {
  title: string
  hint?: string
  icon?: ReactNode
  className?: string
}

/**
 * Empty-area dashed placeholder (e.g. no training days selected).
 * Visual language aligned with {@link DashedAddButton}.
 */
export function DashedPlaceholder({
  title,
  hint,
  icon,
  className = '',
}: DashedPlaceholderProps) {
  const theme = useTheme()

  return (
    <div
      className={`rounded-2xl border-2 border-dashed flex flex-col items-center justify-center py-8 px-6 ${className}`.trim()}
      style={{ borderColor: theme.cardBorder }}
    >
      {icon != null && (
        <div className="mb-3 text-3xl leading-none" style={{ color: theme.text.muted }}>
          {icon}
        </div>
      )}
      <p className="text-sm font-medium mb-1 text-center" style={{ color: theme.text.muted }}>
        {title}
      </p>
      {hint && (
        <p className="text-xs text-center" style={{ color: theme.text.muted, opacity: 0.6 }}>
          {hint}
        </p>
      )}
    </div>
  )
}
